import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Section from './Section';

const Details = ( { e, layout } ) => {
    const [ view, setView ] = useState( [] );

    useEffect( () => {
        if ( layout ) {
            console.log( layout.key );
            console.log( e );
            console.log( e[layout.key] );
            if ( layout.key && layout[e[layout.key]] ) {
                setView( layout[e[layout.key]] );
            } else {
                setView( layout.default );
            }
        }
    }, [ layout, e ] );

    return (
        <Container fluid className='p-0'>
            {
                view.map( ( v, idx ) => (
                    <Section key={`section-${idx}`} title={v.title} body={v.body} e={e} />
                ) )
            }
        </Container>
    )
}

const mapProps = ( state ) => ( {
    // e: state.events.current.details,
    // layout: state.user.meta.event.details
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.contacts.loadContactDetails
} );
  
export default connect( mapProps, mapDispatch )( Details );